import Vue from "vue"
import store from "./providers/store"
import router from "./providers/router"
import App from "./App.vue"

// import helperAuth from "./mixins/helperAuth"
import helperGlobals from "./mixins/helperGlobals"
import helperTitle from "./mixins/helperTitle"

import "./bootstrap.js"
// import "./registerServiceWorker"

Vue.config.productionTip = false

new Vue({
  mixins: [ helperGlobals, helperTitle ],
  router,
  store,
  data () {
    return {
      appPath: process.env.VUE_APP_URL,
      appStorage: process.env.VUE_APP_URL + "storage",
      uik: {
        datepicker: {
          valueFormat: "YYYY-MM-DD HH:mm:ss"
        }
      }
    }
  },
  render: h => h(App)
}).$mount("#app")
